import { render, staticRenderFns } from "./exhibition-info-wrapper.vue?vue&type=template&id=3c6b058f&scoped=true&"
import script from "./exhibition-info-wrapper.vue?vue&type=script&lang=js&"
export * from "./exhibition-info-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-info-wrapper.vue?vue&type=style&index=0&id=3c6b058f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6b058f",
  null
  
)

export default component.exports